const state = {
  dadosFechamentoSla: Array
}

const mutations = {
  setDadosFechamentoSla (state, obj) {
    state.dadosFechamentoSla = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/dadosFechamentoSla.js